import { FreeFormAnswerModel } from './FreeFormAnswerModel'

export class FeedbackSubmitModel {
  public sharedId: string | null = null
  public answers: FreeFormAnswerModel[] = [];

  constructor (sharedId: string | null, answers: FreeFormAnswerModel[]) {
    this.sharedId = sharedId
    this.answers = answers
  }
}
